const ROWS = [
  {
    value: "DGC < 1,00",
    interpretation:
      "A distribuidora cumpriu as metas. O DEC/FEC apurados ficaram abaixo do limite estabelecido pela ANEEL.",
    ranking: "Melhores posições no ranking (desempenho positivo).",
  },
  {
    value: "DGC = 1,00",
    interpretation: "A distribuidora operou exatamente na meta.",
    ranking: "Desempenho neutro.",
  },
  {
    value: "DGC > 1,00",
    interpretation:
      "A distribuidora descumpriu as metas. O DEC/FEC apurados superaram os limites permitidos.",
    ranking: "Piores posições no ranking (desempenho insatisfatório).",
  },
];

export function DgcInterpretationTable() {
  return (
    <div className="mt-3 mb-3">
      <p className="text-[13px] font-semibold text-gray-light mb-2">
        Como Interpretar os Resultados do DGC
      </p>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-[11px] text-gray-light">
          <thead>
            <tr>
              <th className="border border-[#e0e0e0] bg-[#f5f5f5] p-1.5 text-left font-semibold">
                Valor do DGC
              </th>
              <th className="border border-[#e0e0e0] bg-[#f5f5f5] p-1.5 text-left font-semibold">
                Interpretação
              </th>
              <th className="border border-[#e0e0e0] bg-[#f5f5f5] p-1.5 text-left font-semibold">
                Situação no Ranking
              </th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row) => (
              <tr key={row.value}>
                <td className="border border-[#e0e0e0] p-1.5 align-top whitespace-nowrap font-medium">
                  {row.value}
                </td>
                <td className="border border-[#e0e0e0] p-1.5 align-top">
                  {row.interpretation}
                </td>
                <td className="border border-[#e0e0e0] p-1.5 align-top">
                  {row.ranking}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-[11px] italic text-[#777] mt-1.5">
        Quanto menor o valor do DGC, melhor é o desempenho da distribuidora.
      </p>
    </div>
  );
}
